




import { Component, Mixins, Prop } from "vue-property-decorator";
import { ITableIndex } from "../../../../domain/format/objects";

@Component
export default class TableIndexPresenter extends Mixins() {
  @Prop()
  tableIndex: ITableIndex;

  get row(): number {
    return this.tableIndex.row;
  }

  get column(): number {
    return this.tableIndex.column;
  }
}
